// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"72e3d952","828":"710edafe"}[chunkId] + ".chunk.js";
};